import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { NgForm } from '@angular/forms';
import { ServerService } from '../service/server/server.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: []
})
export class LoginComponent implements OnInit {
  products = [];
  productObj = {};
  public username: string;
  public password: string;
  public data: object = {};
  public err: string; public err_validation: number = 0;
  public loading = false;
  public lang: any = 1;
  public subscription: Subscription;
  constructor(private http: HttpClient, private router: Router, private serverService: ServerService) { }
  user_login() {
    this.productObj = { "username": this.username, "password": this.password, "step": 1 }//end productObj
    this.subscription = this.serverService.post_address('https://server1.hooshmandsazeh.com', 'login', this.productObj).subscribe(
      (res) => {
        this.data = res;
        if (this.data['num'] == 1 && this.data['status'] == 1) {
          this.err_validation = 0;
          localStorage.clear();
          var user_info = {
            user_id: res['result'][0].user_id,
            username: res['result'][0].user_userName,
            fname: res['result'][0].user_firstName,
            lname: res['result'][0].user_lastName,
            user_title: res['result'][0].user_title,
            lang: this.lang,
          };
          localStorage.setItem("user_info", JSON.stringify(user_info));
          localStorage.setItem('username', JSON.stringify(this.data['result'][0].user_userName));
          localStorage.setItem('fname', JSON.stringify(this.data['result'][0].user_firstName));
          localStorage.setItem('lname', JSON.stringify(this.data['result'][0].user_lastName));
          localStorage.setItem('unit', JSON.stringify(this.data['result'][0].user_unit));
          localStorage.setItem('lang', this.lang);
          var unit = this.data['result'][0].user_unit;
          var unit_array = unit.split(",");
          var unit_array_number = [];
          for (var j = 0; j < unit_array.length; j++) {
            if (unit_array[j] > 0) {
              localStorage.setItem('status', '1');
            }
          }
          localStorage.setItem('server', 'https://server1.hooshmandsazeh.com');
          localStorage.setItem('site', 'https://hooshmandsazeh.com');
          //this.router.navigate(['/home/crm-task/56']);
          this.router.navigate([this.data['result'][0].user_link_input]);
          this.loading = false;
        }//end else if 

        else if (this.data['status'] == 2) {
          this.err_validation = 1;
          this.err = "Please enter the username and password correctly";
          this.loading = false;
        }//emd else
        else {
          this.err_validation = 1;
          this.err = "Error! Please inform the management";
          this.loading = false;
        }//end else
      }
    )
  }//end user_login 

  ngOnInit() {
    if (localStorage.getItem('username') !== undefined && localStorage.getItem('username') !== null) {
      this.username = JSON.parse(<any>localStorage.getItem('username'));
      //this.user_login(2);  
    } //end if 
  }




}//end class
